import { SCAN_SERVICE_TYPE } from '@witmetrics/utils/constants';

const {
  MODEL_BUILDER_V1,
  RETAINER_DIRECT_PRINTED_V1,
  MICHIGAN_SPLINT_V1,
  NIGHTGUARD_V1,
  BLEACHING_TRAY_MODELS_V1,
} = SCAN_SERVICE_TYPE;

export const GRADIENTS = {
  [BLEACHING_TRAY_MODELS_V1]: 'to-green-2/20',
  [MICHIGAN_SPLINT_V1]: 'to-pink-2/20',
  [NIGHTGUARD_V1]: 'to-pink-2/20',
  [MODEL_BUILDER_V1]: 'to-purple-2/20',
  [RETAINER_DIRECT_PRINTED_V1]: 'to-blue-2/15',
  DEFAULT: 'to-blue-200/30',
} as const;
